import { VendorMenuSlice } from './reducer';

export const vendorMenuIsShownSelector = (state: VendorMenuSlice) => {
    return state.vendorMenu.showMenu;
};
